import styled from 'styled-components';
import factoryButton from './utils/factoryButton';
import BaseBtnSC from './styles/BaseBtnSC';
const boxShadowDarkMode = (props) => `${props.theme.SizeShadowButtonActive} ${props.theme.ColorShadowButtonDarkOutlined}`;
const ButtonOutlinedSC = styled(BaseBtnSC) `
  border: ${(props) => props.theme.SizeBorderWeightButtonOutlinedBase} solid
    ${(props) => props.theme.ColorBorderButtonOutlinedBase};

  &._ndsBtn--grey {
    color: ${(props) => props.theme.ColorFontButtonOutlinedGrey};
    border-color: ${(props) => props.theme.ColorBorderButtonOutlinedGrey};
  }

  &._ndsBtn--destructive {
    color: ${(props) => props.theme.ColorFontButtonOutlinedError};
    border-color: ${(props) => props.theme.ColorBorderButtonOutlinedError};
  }

  &._ndsBtn--dark-mode {
    color: ${(props) => props.theme.ColorFontButtonOutlinedDarkBase};
    border-color: ${(props) => props.theme.ColorBorderButtonOutlinedDarkBase};
  }

  & > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonOutlinedBase};
  }

  &._ndsBtn--dark-mode > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonOutlinedDarkBase};
  }

  &._ndsBtn--grey > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonOutlinedGrey};
  }

  &._ndsBtn--destructive > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonOutlinedError};
  }

  :hover {
    background-color: ${(props) => props.theme.ColorBackgroundButtonOutlinedHover};
  }

  &._ndsBtn--grey:hover {
    background-color: ${(props) => props.theme.ColorBackgroundButtonOutlinedGreyHover};
  }

  &._ndsBtn--destructive:hover {
    background-color: ${(props) => props.theme.ColorBackgroundButtonOutlinedErrorHover};
  }

  &._ndsBtn--dark-mode:hover {
    background-color: ${(props) => props.theme.ColorBackgroundButtonOutlinedDarkHover};
  }

  &._ndsBtn--dark-mode:focus,
  &._ndsBtn--dark-mode:active {
    background-color: ${(props) => props.theme.ColorBackgroundButtonOutlinedDarkActive};
  }

  &._ndsBtn--dark-mode:focus::before,
  &._ndsBtn--dark-mode:active::before {
    box-shadow: ${boxShadowDarkMode};
  }

  &._ndsBtn--dark-mode:disabled {
    color: ${(props) => props.theme.ColorFontButtonOutlinedDarkDisabled};
    border-color: ${(props) => props.theme.ColorBorderButtonOutlinedDarkDisabled};
    background-color: transparent;
  }

  &._ndsBtn--grey:disabled,
  &._ndsBtn--destructive:disabled,
  :disabled {
    border-color: ${(props) => props.theme.ColorBorderButtonOutlinedDisabled};
    background-color: transparent;
    color: ${(props) => props.theme.ColorFontButtonOutlinedDisabled};
  }

  &._ndsBtn--loading:disabled {
    border-color: ${(props) => props.theme.ColorBorderButtonOutlinedLoading};
    background-color: ${(props) => props.theme.ColorBackgroundButtonOutlinedLoading};
    color: ${(props) => props.theme.ColorFontButtonOutlinedLoading};
  }

  &._ndsBtn--grey._ndsBtn--loading:disabled {
    border-color: ${(props) => props.theme.ColorBorderButtonOutlinedGrey};
    background-color: ${(props) => props.theme.ColorBackgroundButtonOutlinedGreyLoading};
    color: ${(props) => props.theme.ColorFontButtonOutlinedGreyLoading};
  }

  &._ndsBtn--destructive._ndsBtn--loading:disabled {
    border-color: ${(props) => props.theme.ColorBorderButtonOutlinedError};
    background-color: ${(props) => props.theme.ColorBackgroundButtonOutlinedErrorLoading};
    color: ${(props) => props.theme.ColorFontButtonOutlinedErrorLoading};
  }

  &._ndsBtn--dark-mode._ndsBtn--loading:disabled {
    opacity: 1;
    background-color: ${(props) => props.theme.ColorBackgroundButtonOutlinedDarkHover};
    color: ${(props) => props.theme.ColorFontButtonOutlinedDarkBase};
    border-color: ${(props) => props.theme.ColorBorderButtonOutlinedDarkBase};
  }

  :disabled > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonOutlinedDisabled};
  }

  &._ndsBtn--dark-mode:disabled > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonOutlinedDarkDisabled};
  }
`;
export default factoryButton(ButtonOutlinedSC, 'outlined');
//# sourceMappingURL=ButtonOutlined.js.map